import React, { useEffect, useState } from "react";
import { FavouriteIcon, ProfileIcon } from "../../data/menu_svg"
import IconGenerator from "../Util/IconGenerator";
import $ from "jquery"


const NavHeader = React.memo(function NavHeader({ visibility, exitBtnvisible, extToExplore, pageKey, handleFavoriteVisibility, callProfileApiStatus }) {
    const [iconVisible, setIconVisible] = useState(visibility)
    const [exitVisible, setExitVisible] = useState(exitBtnvisible)

    const handleExit = () => {

        if (pageKey === "slider") {



            extToExplore("tools_support_fypon")

        }


        if (pageKey === "keysuccess") {

            extToExplore('thermatru_key_success')

        }

    }

    useEffect(() => {

        setIconVisible(visibility)

    }, [visibility])

    useEffect(() => {

        setExitVisible(exitBtnvisible)

    }, [exitBtnvisible])


    const handleProfile = () => {

        callProfileApiStatus()
        $("#profile_wrapper").removeClass('d-none');
        $("#favModal").modal('hide')

    }

    const handleFavourites = (val) => {
        $("#profile_wrapper").addClass('d-none');

        handleFavoriteVisibility(true)
        $("#favModal").modal('show')
        $(".navigation-container").hide();
        $(".nav-header-div").hide();

    }

    return (
        <div className="nav-header-div">

            {
                iconVisible &&
                <>

                    <IconGenerator iconTitle="Profile" IconSvg={FavouriteIcon} uiChangeFunc={handleProfile} />
                    <IconGenerator iconTitle="Favorites" IconSvg={ProfileIcon} uiChangeFunc={handleFavourites} />

                </>
            }

            {
                exitVisible &&
                <>

                    <a href="#" className="btn  exit_btn" onClick={handleExit}>Exit</a>

                </>
            }


        </div>
    )


});

export default NavHeader